var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderDarkVentiAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 75,
    viewBox: "0 0 150 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.46 0H0.459961V75H149.46V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 50.9309L40.7421 59.6166L34.9818 60.775L22.554 62.7035V74.755L49.9233 67.4786V53.9277L0 37.3799V50.9309Z",
    fill: "#5758F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.8757L40.7421 15.19L34.9818 14.0337L22.554 12.1052V0.0537109L49.9233 7.3301V20.8811L0 37.4289V23.8757Z",
    fill: "#5758F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9805 50.9309L90.7226 59.6166L84.9623 60.775L72.5345 62.7035V74.755L99.9038 67.4786V53.9277L49.9805 37.3799V50.9309Z",
    fill: "#5758F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9805 23.8757L90.7226 15.19L84.9623 14.0337L72.5345 12.1052V0.0537109L99.9038 7.3301V20.8811L49.9805 37.4289V23.8757Z",
    fill: "#5758F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 50.9309L140.702 59.6166L134.942 60.775L122.514 62.7035V74.755L149.883 67.4786V53.9277L99.96 37.3799V50.9309Z",
    fill: "#5758F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 23.8757L140.702 15.19L134.942 14.0337L122.514 12.1052V0.0537109L149.883 7.3301V20.8811L99.96 37.4289V23.8757Z",
    fill: "#5758F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderDarkVentiAsset);
export default __webpack_public_path__ + "static/media/headerDarkVentiAsset.eaaba3e19c8fc9a83804619475a45036.svg";
export { ForwardRef as ReactComponent };